<table *ngIf="item.componentStatuses.length > 0" class="cas-table-expandable-row-table">
    <thead>
        <tr>
            <th>
            </th>
            <th>
                Name
            </th>
            <th>
                Data Rate
            </th>
            <th>
                Last Changed
            </th>
            <th>
                Poll Count
            </th>
            <th>
                Last Updated
            </th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let item of item.componentStatuses">
            <td>
                <mat-icon [ngClass]="item.$status.cls" class="icon-{{item.$status.size}}px"
                          [matTooltip]="item.$status.statusDescription" matTooltipPosition="left">
                    {{ item.$status.icon }}
                </mat-icon>
            </td>
            <td>{{item.name}}</td>
            <td [ngClass]="textAccentClass">{{item.dataRate}}</td>
            <td>{{item.lastChanged| date:'M/d/yy, h:mm:ss a'}}</td>
            <td>{{item.pollCount}}</td>
            <td>{{item.lastUpdated| date:'M/d/yy, h:mm:ss a'}}</td>
        </tr>
    </tbody>
</table>
<div *ngIf="item.componentStatuses.length === 0" class="no-status-label">
    No Reader Statuses!
</div>